// Нүүрний асуулгын карт(ууд) — эцэг эх, сурагчийн нүүрт. Нээлттэй асуулга бүрт нэг карт: гарчиг, тайлбар, асуултын тоо,
// хаагдах огноо, «Бөглөх» / «Үргэлжлүүлэх» / «Бөглөсөн — баярлалаа». Нүүрэнд автоматаар нээгдэхгүй — эцэг эх карт дээр дарж бөглөнө.
import React, { useEffect, useState } from "react";
import { FiCheck, FiStar } from "react-icons/fi";
import { instance } from "utils/axios";
import { dueText } from "utils/due";
import SurveyFlow from "./Flow";

export function SurveyCard({ s, onOpen }) {
  const started = s.items.some((i) => !i.submitted && i.answered > 0);
  const kids = s.items.filter((i) => i.child).length;
  return (
    <section aria-label="Асуулга" className="rounded-[18px] md:rounded-[20px] p-4 md:px-6 md:py-5 flex flex-col gap-2.5 text-white bg-gradient-to-br from-primary to-[#8b2fd1]">
      <span className="inline-flex items-center gap-1.5 text-[11px] md:text-xs font-bold tracking-[0.12em] uppercase text-white/80">
        <FiStar size={13} className="fill-[#f2cd30] text-[#f2cd30]" />Асуулга{s.closeAt && !s.done ? ` · ${dueText(s.closeAt)}` : ""}
      </span>
      <h2 className="m-0 text-lg md:text-xl font-bold leading-snug">{s.title}</h2>
      {s.description && <p className="m-0 text-sm md:text-[15px] leading-relaxed text-white/85 whitespace-pre-line">{s.description}</p>}
      <span className="text-[13px] text-white/75">
        {s.total} асуулт{kids > 1 ? ` · ${kids} хүүхэд` : ""}
      </span>
      {s.done ? (
        <span className="self-start mt-1 inline-flex items-center gap-2 h-9 px-3.5 rounded-full bg-white/15 text-sm font-semibold">
          <FiCheck size={16} strokeWidth={2.6} />Бөглөсөн — баярлалаа
        </span>
      ) : (
        <button onClick={() => onOpen(s.id)} className="self-start mt-1 h-11 px-6 rounded-full bg-white text-primary text-[15px] font-bold hover:bg-[#f3eeff]">
          {started ? "Үргэлжлүүлэх" : "Бөглөх"}
        </button>
      )}
    </section>
  );
}

// only — зөвхөн энэ асуулгыг харуулна (/survey/:id); autoOpen — тэр асуулгыг шууд нээнэ
export default function SurveyCards({ only, autoOpen = false, onLoaded }) {
  const [list, setList] = useState(null);
  const [open, setOpen] = useState(null);

  const load = (first) =>
    instance({ method: "get", url: "/surveys/mine" })
      .then((res) => {
        const all = Array.isArray(res.data) ? res.data : [];
        const l = only ? all.filter((s) => s.id === Number(only)) : all;
        setList(l);
        onLoaded && onLoaded(l);
        // Нүүрэнд хүчээр нээхгүй — зөвхөн /survey/:id холбоосоор орж ирвэл шууд нээнэ
        if (first && autoOpen && l[0] && !l[0].done) setOpen(l[0].id);
      })
      .catch(() => { setList([]); onLoaded && onLoaded([]); });

  useEffect(() => { load(true); }, [only]); // eslint-disable-line react-hooks/exhaustive-deps

  const close = () => { setOpen(null); load(false); };

  return (
    <>
      {(list || []).map((s) => <SurveyCard key={s.id} s={s} onOpen={setOpen} />)}
      {open && <SurveyFlow id={open} onClose={close} />}
    </>
  );
}
